import {
  GET_PAYROLL_DOCUMENTS, GET_PAYROLL_DOCUMENTS_SUCCESS, GET_PAYROLL_DOCUMENTS_FAILURE,
  REQUEST_PAYROLL_LINK, REQUEST_PAYROLL_LINK_SUCCESS, REQUEST_PAYROLL_LINK_FAILURE,
  GET_PAYROLL_DOCUMENT, GET_PAYROLL_DOCUMENT_SUCCESS, GET_PAYROLL_DOCUMENT_FAILURE,
  GET_PAYROLL_DOWNLOAD_URL, GET_PAYROLL_DOWNLOAD_URL_FAILURE
} from './mutation-types'

//
// 給与・賞与明細（F-PAY-02 / F-PAY-04）
//
// 明細の表示にはメールで届くワンタイムリンク（15分有効）のトークンが必要。
//
export default {
  state: {
    payrollDocuments: null,
    payrollDocument: null,
    payrollMessage: null,
    payrollError: null,
    payrollForbidden: false
  },
  getters: {
    payrollDocuments: state => {
      return state.payrollDocuments
    },
    payrollDocument: state => {
      return state.payrollDocument
    },
    payrollMessage: state => {
      return state.payrollMessage
    },
    payrollError: state => {
      return state.payrollError
    },
    payrollForbidden: state => {
      return state.payrollForbidden
    }
  },
  actions: {
    // 本人分の明細一覧（支給日の前日以降）
    [GET_PAYROLL_DOCUMENTS] ({dispatch, state, commit}, params = null) {
      state.payrollForbidden = false
      return dispatch('apiGet', {url: '/asovi/payroll/documents', data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_PAYROLL_DOCUMENTS_FAILURE, res.data)
          } else {
            commit(GET_PAYROLL_DOCUMENTS_SUCCESS, {data: res.data, callback: params ? params.callback : null})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.payrollForbidden = true
        }
        console.log('GET_PAYROLL_DOCUMENTS error', error)
        commit(GET_PAYROLL_DOCUMENTS_FAILURE, {})
        if (params && params.callback) params.callback()
      })
    },
    // 閲覧用ワンタイムリンクのメール送信
    [REQUEST_PAYROLL_LINK] ({dispatch, state, commit}, params) {
      state.payrollMessage = null
      state.payrollError = null
      return dispatch('apiPost', {url: '/asovi/payroll/documents/' + params.id + '/request_link', data: {}, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REQUEST_PAYROLL_LINK_FAILURE, res.data)
          } else {
            commit(REQUEST_PAYROLL_LINK_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('REQUEST_PAYROLL_LINK error', error)
        commit(REQUEST_PAYROLL_LINK_FAILURE, {error: 'リンクの送信に失敗しました。通信環境をご確認ください。'})
      })
    },
    // 明細PDFのダウンロード用署名URL（有効5分・ワンタイム）を発行する
    // 発行には画面閲覧用トークン（15分）が必要
    [GET_PAYROLL_DOWNLOAD_URL] ({dispatch, state, commit}, params) {
      state.payrollError = null
      return dispatch('apiPost', {url: '/asovi/payroll/documents/' + params.id + '/download_url?token=' + params.token, data: {}, isLoading: true})
      .then(res => {
        if (res.data && res.data.error) {
          commit(GET_PAYROLL_DOWNLOAD_URL_FAILURE, res.data)
          return
        }
        if (params.callback) {
          params.callback(res.data)
        }
      })
      .catch(error => {
        var message = '有効時間を過ぎました。もう一度リンクをメールで受け取ってください。'
        if (error.response && error.response.status === 404) {
          message = '明細PDFがまだ生成されていません。'
        }
        console.log('GET_PAYROLL_DOWNLOAD_URL error', error)
        commit(GET_PAYROLL_DOWNLOAD_URL_FAILURE, {error: message})
      })
    },
    // 個別明細（トークン必須）
    [GET_PAYROLL_DOCUMENT] ({dispatch, state, commit}, params) {
      state.payrollError = null
      return dispatch('apiGet', {url: '/asovi/payroll/documents/' + params.id, data: {token: params.token}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_PAYROLL_DOCUMENT_FAILURE, res.data)
          } else {
            commit(GET_PAYROLL_DOCUMENT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = ' 明細を表示できませんでした。'
        if (error.response && error.response.status === 401) {
          message = 'リンクの有効期限が切れています。給与明細一覧から再度リンクを送信してください。'
        } else if (error.response && error.response.status === 403) {
          state.payrollForbidden = true
          message = 'この画面を表示する権限がありません。'
        }
        commit(GET_PAYROLL_DOCUMENT_FAILURE, {error: message})
        if (params.callback) params.callback()
      })
    }
  },
  mutations: {
    [GET_PAYROLL_DOWNLOAD_URL_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOWNLOAD_URL_FAILURE')
      state.payrollError = data.error
    },
    [GET_PAYROLL_DOCUMENTS_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOCUMENTS_FAILURE')
      state.payrollDocuments = []
    },
    [GET_PAYROLL_DOCUMENTS_SUCCESS] (state, data) {
      console.log('GET_PAYROLL_DOCUMENTS_SUCCESS')
      state.payrollDocuments = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [REQUEST_PAYROLL_LINK_FAILURE] (state, data) {
      console.log('REQUEST_PAYROLL_LINK_FAILURE')
      state.payrollError = data.error
    },
    [REQUEST_PAYROLL_LINK_SUCCESS] (state, data) {
      console.log('REQUEST_PAYROLL_LINK_SUCCESS')
      state.payrollMessage = data.data.success
      if (data.callback) {
        data.callback()
      }
    },
    [GET_PAYROLL_DOCUMENT_FAILURE] (state, data) {
      console.log('GET_PAYROLL_DOCUMENT_FAILURE')
      state.payrollDocument = null
      state.payrollError = data.error
    },
    [GET_PAYROLL_DOCUMENT_SUCCESS] (state, data) {
      console.log('GET_PAYROLL_DOCUMENT_SUCCESS')
      state.payrollDocument = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payroll.js